import * as actionTypes from "../actions/actionTypes";

let initialState = {
  locations: null,
  detectLocation: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LOCATIONS:
      return {
        ...state,
        locations: action.payload,
      };
    case actionTypes.SET_DETECT_LOCATION:
      return {
        ...state,
        detectLocation: action.payload,
      };
    case actionTypes.REMOVE_LOCATIONS:
      return {
        ...state,
        locations: null,
      };
    default:
      return state;
  }
};

export default reducer;
